export function IdCardIcon({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M8.33333 5H4.16667C3.24619 5 2.5 5.74619 2.5 6.66667V14.1667C2.5 15.0871 3.24619 15.8333 4.16667 15.8333H15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1667V6.66667C17.5 5.74619 16.7538 5 15.8333 5H11.6667M8.33333 5V4.16667C8.33333 3.24619 9.07953 2.5 10 2.5C10.9205 2.5 11.6667 3.24619 11.6667 4.16667V5M8.33333 5C8.33333 5.92047 9.07953 6.66667 10 6.66667C10.9205 6.66667 11.6667 5.92047 11.6667 5M7.5 11.6667C8.42047 11.6667 9.16667 10.9205 9.16667 10C9.16667 9.07953 8.42047 8.33333 7.5 8.33333C6.57953 8.33333 5.83333 9.07953 5.83333 10C5.83333 10.9205 6.57953 11.6667 7.5 11.6667ZM7.5 11.6667C8.58852 11.6667 9.5145 12.3623 9.8577 13.3333M7.5 11.6667C6.41148 11.6667 5.48541 12.3623 5.14221 13.3333M12.5 9.16667H15M12.5 12.5H14.1667" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "IdCardIcon";
